// extracted by mini-css-extract-plugin
module.exports = {"tags":"LKTagCloud_tags__1MAAL","tag":"LKTagCloud_tag__3-Xnc","colorBase":"LKTagCloud_colorBase__3lII4","colorAccent":"LKTagCloud_colorAccent__1pU2Y"};